"use client";

import { AutocompleteSelect } from "@/components/ui/autocomplete-select";
import { useRouter } from "@bprogress/next";
import { cn, isDefined, updateSearchParams } from "@/lib/utils";
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { trans } from "@/service/i18n/i18n";

export function SelectFilter({
  filter,
  onChange,
  disabled = false,
  hideArrow = false,
  arrowInsteadX = false,
  buttonClassName,
  preventSearchParamsUpdate = false,
}: {
  filter: Filter;
  onChange?: (option: any) => void;
  disabled?: boolean;
  hideArrow?: boolean;
  arrowInsteadX?: boolean;
  buttonClassName?: string;
  preventSearchParamsUpdate?: boolean;
}) {
  const { name, placeholder, options } = filter;
  const router = useRouter();
  const [currentValue, setCurrentValue] = useState(filter.value ?? null);
  // used only for clearing filter when search params change
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!searchParams.has(name)) {
      setCurrentValue(filter.value ?? null);
    }
  }, [searchParams, name, filter.value]);
  //

  useEffect(() => {
    setCurrentValue(filter.value ?? null);
  }, [filter.value]);

  return (
    <div className={"w-full"}>
      <AutocompleteSelect
        onChange={(option: SelectFieldOption | null) => {
          if (onChange) {
            onChange(option);
          }

          const value = ![null, undefined].includes(option?.value)
            ? option.value
            : null;
          setCurrentValue(value);

          if (!preventSearchParamsUpdate) {
            updateSearchParams(
              name,
              option && isDefined(option.value) ? String(option.value) : null,
              router,
            );
          }
        }}
        selected={options?.find((option) => option.value === currentValue)}
        placeholder={placeholder}
        defaultOptions={options?.map((option) => ({
          name: trans(option.name),
          value: option.value,
        }))}
        disabled={filter.disabled || disabled}
        renderWithoutPortal={false}
        buttonClassName={cn(
          "border-zinc-400 text-sm text-foreground",
          buttonClassName,
        )}
        hideArrow={hideArrow}
        arrowInsteadX={arrowInsteadX}
      ></AutocompleteSelect>
    </div>
  );
}
